module.exports = __webpack_public_path__ + "img/icon_grid_plus.5adc1969.svg";